import { graphql as coreGraphqlTypes } from '@sitebuilder/core';

export * as fundList from './fundList';
export * as webProfiles from './webProfiles';

export * as fundListViewModelTypes from './fundList/viewModelTypes';
export * as webProfilesViewModelTypes from './webProfiles/viewModelTypes';
export { QueryApiClient } from './queryApiClient';

class GraphqlClient implements coreGraphqlTypes.IGraphqlClient {
    authorizationToken: string;
    dataSourcesMap?: Record<string, string>;

    constructor(authorizationToken: string, dataSourcesMap?: Record<string, string>) {
        this.authorizationToken = authorizationToken;
        this.dataSourcesMap = dataSourcesMap;
    }

    async query<T>(dataSource: string, params: coreGraphqlTypes.GraphqlQueryParameters) {
        const { query, extensions, variables } = params;
        const operationName = undefined;
        let data: T | undefined;

        try {
            if (typeof dataSource !== 'string' || dataSource.length < 1) {
                return { data: {}, errors: [{ message: 'dataSource missing' }] } as any as T;
            }

            if (this.dataSourcesMap && this.dataSourcesMap[dataSource]) {
                dataSource = this.dataSourcesMap[dataSource];
            }

            const results = await fetch(`/api/graphql/${dataSource}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `bearer ${this.authorizationToken}`,
                },
                body: JSON.stringify({ operationName, query, variables, extensions }),
            });
            data = (await results.json()) as T;
        } catch (error) {
            console.error(error);
        }

        return data;
    }
}

export interface IGraphqlClientFactory {
    createClient: (
        authorizationToken: string,
        dataSourcesMap?: Record<string, string>
    ) => coreGraphqlTypes.IGraphqlClient;
}

export class GraphqlClientFactory implements IGraphqlClientFactory {
    createClient(authorizationToken: string, dataSourcesMap?: Record<string, string>) {
        return new GraphqlClient(authorizationToken, dataSourcesMap);
    }
}
